import { Injectable } from '@angular/core'
import { Query } from '@datorama/akita'
import { RegisterState, RegisterStore } from './register.store'

@Injectable({ providedIn: 'root' })
export class RegisterQuery extends Query<RegisterState> {
  constructor(protected store: RegisterStore) {
    super(store)
  }

  selectSettings$ = this.select('settings')

  hasSettings(): boolean {
    return this.getValue().settings !== null
  }
}
